/**
 * 过滤规则，通过规则过滤一些已经投注的号码
 * 权重区间： 50000 - 40000 步长100
 */

export default function Filters(R){
	return [
		// 单式去重
		{
			priority: 50000,
			condition: function(R) {
		        R.when( _.includes(this.ruleSuite, 'filter-input-unqiue') );
		    },
		    consequence: function(R) {
		    	let num = 0;
		    	let realCode = _.chain(this.formatCodes).split(/(,| |;)/).without(',',' ',';','').value();
		    	let uniqueCode = _.uniq(realCode);
		    	if (realCode.length != uniqueCode.length) {
		    		this.message.push('已经自动去重');
		    	}
		    	this.formatCodes = uniqueCode;
		        R.next();
		    }
		},
		// 单式正则过滤
		{
			priority: 48000,
			condition: function(R) {
		        R.when( _.includes(this.ruleSuite, 'filter-input-regex') );
		    },
		    consequence: function(R) {
		    	let errorCodes = [];
		    	let currentCodes = [];
		    	this.attached.scope = this.attached.scope || '0-9';
		    	// 构建正则表达式
		    	let regex = new RegExp('^['+this.attached.scope+'\s]{'+this.attached.number+'}$')
		    	_.forEach(this.formatCodes, function(item){
		    		if(regex.test(item)){
		    			currentCodes.push(item);
		    		}else{
		    			if (!_.isUndefined(item) ) {
		    				errorCodes.push(item)
		    			}
		    		}
		    	})
		    	if (errorCodes.length > 0) {
		    		this.message.push('以下号码错误，已进行自动过滤');
		    		this.message.push( _.join(errorCodes, ',') );
		    	}
		    	this.formatCodes = currentCodes;
		        R.next();
		    }
		}
		
	]
}